import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react/components/shared/uikit/Typography";

export const NoUnreadMessages = () => (
  <div className="flex size-full flex-col items-center justify-start pt-12">
    <Typography.LabelSm>{t("messaging.no_messages")}</Typography.LabelSm>
  </div>
);
